"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetImage = void 0;
exports.AssetCardImage = AssetCardImage;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const get_cdn_image_url_1 = require("@src/shared/get-cdn-image-url");
const get_asset_image_source_1 = require("@src/shared/get-asset-image-source");
exports.AssetImage = styled_components_1.default.img `
	object-fit: contain;
	height: 100%;
	width: 100%;
`;
function AssetCardImage({ asset }) {
    const assetImageUrl = (0, get_cdn_image_url_1.getCdnImageUrl)({
        file: (0, get_asset_image_source_1.getAssetImageSource)(asset),
        transformation: 'w_400,c_scale',
        shouldIncludeEnvironmentPart: false,
    });
    return (0, jsx_runtime_1.jsx)(exports.AssetImage, { src: assetImageUrl, alt: "image-asset" });
}
